import { createApiSlice } from "@common";
import { CRUD_COMPETITOR } from "@routes";

const apiConfig = [
  {
    name: "addCompetitor",
    method: "post",
    url: CRUD_COMPETITOR,
    stateKey: "message",
  },
  {
    name: "getCompetitor",
    method: "get",
    url: CRUD_COMPETITOR,
    stateKey: "data",
  },
  {
    name: "updateCompetitor",
    method: "put",
    url: CRUD_COMPETITOR,
    stateKey: "message",
  },
  {
    name: "deleteCompetitor",
    method: "delete",
    url: CRUD_COMPETITOR,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"competitor",
 apiConfig, 
 customReducers);
const competitorSlice = slice;

export default competitorSlice.reducer;

export const {
  addCompetitor,
  getCompetitor,
  updateCompetitor,
  deleteCompetitor,
} = thunks;

export const { rowSelect } = actions;
